<template>
  <DialogFull
    :data="dialogSettings"
    v-if="dialogSettings.dialog"
    @close="close"
  >
    <template v-slot:dialog.body>
      <div class="container mt-10">
        <PageForm
          ref="pageForm"
          :isUpdate="isUpdate"
          :micrositeId="micrositeId"
          :micrositePage="isUpdate ? micrositePage : {}"
          :displayOrder="displayOrder"
          @onSubmit="submit"
        />
      </div>
    </template>
    <template v-slot:dialog.action>
      <PrimaryButton @click.native="validateForm" :loading="isLoading">
        {{ buttonLabel }}
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { MICROSITE_NAMESPACE } from "@/store/modules/microsites";
import {
  ADD_MICROSITE_PAGE,
  EDIT_MICROSITE_PAGE
} from "@/store/modules/microsites/actions";
import PageForm from "@/views/settings/components/microsites/components/PageForm";

const { mapActions } = createNamespacedHelpers(MICROSITE_NAMESPACE);
export default {
  props: {
    isOpen: Boolean,
    isUpdate: Boolean,
    micrositeId: String,
    micrositePage: Object,
    displayOrder: Number
  },
  components: {
    PrimaryButton,
    DialogFull,
    PageForm
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: `${this.isUpdate ? "Edit" : "New"} Microsite Page`
      };
    },
    buttonLabel() {
      return this.isUpdate ? "Save Changes" : "Create Page";
    }
  },
  methods: {
    ...mapActions({
      addMicrositePage: ADD_MICROSITE_PAGE,
      editMicrositePage: EDIT_MICROSITE_PAGE
    }),
    validateForm() {
      this.$refs.pageForm.validateForm();
    },
    async submit(page) {
      this.isLoading = true;
      this.isUpdate
        ? await this.editMicrositePage(page)
        : await this.addMicrositePage(page);
      this.isLoading = false;
      this.close();
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
